import type { CSSProperties } from "react";
import { iconUrl, portraitUrl } from "./manifest.js";

export interface AssetIconProps {
  id: string;
  size?: number;
  className?: string;
  style?: CSSProperties;
  alt?: string;
  /** Unit portrait instead of the full-body icon. */
  portrait?: boolean;
  /** Show the same building tier as the actual scene, rather than the catalogue's default tier 2. */
  buildingLevel?: number;
}

/** Renders a pipeline icon (never a hand-drawn image, R95) with the 1x/2x pair. */
export function AssetIcon({ id, size = 64, className = "", style, alt = "", portrait = false, buildingLevel }: AssetIconProps) {
  // Buildings ship tier icons instead of an @1x pair, so every icon uses the full-size file.
  const src = portrait ? portraitUrl(id) : iconUrl(id, "2x", buildingLevel);
  return <img src={src} width={size} height={size} alt={alt} className={className} style={{ display: "block", objectFit: "contain", ...style }} loading="lazy" decoding="async" draggable={false} />;
}
